import { CLICK_FROM, CLICK_TO, CLICK_MAP, CHANGE_FROM, CHANGE_TO, FIND_ALL_ROUTES, FIND_ALL_ROUTES_SUCESS, FIND_ALL_ROUTES_FAIL, CLOSE_ALL_ROUTES, FIND_ITINERARIES, FIND_ITINERARIES_SUCCESS, FIND_ITINERARIES_FAIL, TOGGLE_CODESHARE_CHECK, GET_ITINERARIES_NETWORK, GET_ITINERARIES_NETWORK_SUCCESS, GET_ITINERARIES_NETWORK_FAIL, TOGGLE_ROUTE_OPTIONS, CHANGE_ITINERARIES_DAY, SELECT_ITINERARY_OPTION, CLOSE_ROUTE, SET_ARRIVAL, SET_DEPARTURE, CLICK_MARKER, CHANGE_STOP_OPTION, SHOW_ALERT, CLOSE_ALERT, GET_ROUTE_PRICE, GET_ROUTE_PRICE_SUCCESS, GET_ROUTE_PRICE_FAILED, SHOW_ROUTE_PRICE, HIDE_ROUTE_PRICE, LOG_FIND_ROUTE } from './types';

export const clickFrom = () => ({
    type: CLICK_FROM
});

export const clickTo = () => ({
    type: CLICK_TO
});

export const clickMap = () => ({
    type: CLICK_MAP
});

export const changeFrom = (from) => ({
    type: CHANGE_FROM,
    payload: { from }
});

export const changeTo = (to) => ({
    type: CHANGE_TO,
    payload: { to }
});

export const closeRoute = () => ({
    type: CLOSE_ROUTE
});

export const setDeparture = (from, to, airportNameCode, filters) => ({
    type: SET_DEPARTURE,
    payload: { from, to, airportNameCode, filters }
});

export const setArrival = (to, from, airportNameCode, filters) => ({
    type: SET_ARRIVAL,
    payload: { to, from, airportNameCode, filters }
});

export const clickMarker = (markerId) => ({
    type: CLICK_MARKER,
    payload: { markerId }
});

export const findAllRoutes = (fromCode, from, filters) => ({
    type: FIND_ALL_ROUTES,
    payload: { fromCode, from, filters }
});

export const findAllRoutesSucess = data => ({
    type: FIND_ALL_ROUTES_SUCESS,
    payload: { data }
});

export const findAllRoutesFail = error => ({
    type: FIND_ALL_ROUTES_FAIL,
    payload: { error }
});

export const closeAllRoutes = () => ({
    type: CLOSE_ALL_ROUTES
});

export const findItineraries = (from, to, filters) => ({
    type: FIND_ITINERARIES,
    payload: { from, to, filters }
});

export const findItinerariesFail = (error) => ({
    type: FIND_ITINERARIES_FAIL,
    payload: { error }
});

export const findItinerariesSucess = (data, from, to) => ({
    type: FIND_ITINERARIES_SUCCESS,
    payload: { data, from, to }
});

export const selectItineraryOption = (idx) => ({
    type: SELECT_ITINERARY_OPTION,
    payload: { idx }
});

export const getItinerariesNetwork = (filters) => ({
    type: GET_ITINERARIES_NETWORK,
    payload: { filters }
});

export const getItinerariesNetworkSuccess = (data) => ({
    type: GET_ITINERARIES_NETWORK_SUCCESS,
    payload: { data }
});

export const getItinerariesNetworkFail = (err) => ({
    type: GET_ITINERARIES_NETWORK_FAIL,
    payload: { err }
});

export const changeItinerariesDay = (day) => ({
    type: CHANGE_ITINERARIES_DAY,
    payload: { day }
});

export const toggleRouteOptions = (showSidebar) => ({
    type: TOGGLE_ROUTE_OPTIONS,
    payload: { showSidebar }
});

export const changeStopOption = (stopOption) => ({
    type: CHANGE_STOP_OPTION,
    payload: { stopOption }
});

export const toggleCodeshareCheck = checked => ({
    type: TOGGLE_CODESHARE_CHECK,
    payload: { checked }
});

export const showAlert = (alert) => ({
    type: SHOW_ALERT,
    payload: { alert }
});

export const closeAlert = () => ({
    type: CLOSE_ALERT
});

export const getRoutePrice = (lang) => ({
    type: GET_ROUTE_PRICE,
    payload: { lang }
});

export const getRoutePriceSuccess = (data) => ({
    type: GET_ROUTE_PRICE_SUCCESS,
    payload: { data }
});

export const getRoutePriceFail = () => ({
    type: GET_ROUTE_PRICE_FAILED
});

export const showRoutePrice = (from, to) => ({
    type: SHOW_ROUTE_PRICE,
    payload: { from, to }
});

export const hideRoutePrice = () => ({
    type: HIDE_ROUTE_PRICE
});